export const FREE_TRIAL_DAYS = 30;
export const ANNUAL_MEMBERSHIP_PRICE = 120_00; // $120
